// extracted by mini-css-extract-plugin
export default {"box":"ExtendText_box__S3jqu","icon":"ExtendText_icon__4Ydsn","text--tn--default":"ExtendText_text--tn--default__vuDIi"};